import { NavLink, Navigate } from 'react-router-dom'

import { GetText } from 'shared/i18n'
import { isAuthenticated, useCurrentUser } from 'shared/auth'

import useLogIn from './use-log-in'
import LoginFailure from './login-failure'
import LogInForm from './login-form'

export default function LogIn() {
  const currentUser = useCurrentUser()
  const { logIn, failure } = useLogIn()

  if (isAuthenticated(currentUser)) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="w-full px-4 py-8 sm:m-auto sm:w-[28rem] sm:px-8">
      {failure && <LoginFailure code={failure} />}

      <LogInForm className="mb-8" onSubmit={logIn} />

      <GetText
        components={{ link: <NavLink to="/get-involved" className="link" /> }}
      >
        Don't have an account? Learn how to [link]get involved[/link].
      </GetText>
    </div>
  )
}
